import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {GetHeaderBannerResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/category_page/v1/navigation/service.types';
import React, {useMemo} from 'react';
import {CouponBanner} from '../Coupons/CouponBanner/CouponBanner';
import {AdvertisementBanner} from './AdvertisementBanner';
import {SponsoredBanner} from './SponsoredBanner';
import {TrackEmptyBanner} from './TrackEmptyBanner';

export const HeaderBanner: React.FC<GetHeaderBannerResponse> = ({
  type,
  highTierCouponBanner,
}) => {
  const {isActive} = useIsFeatureActive('high_tier_coupons');

  const banner = useMemo(() => {
    switch (type?.$case) {
      case 'advertisement':
        return <AdvertisementBanner advertisement={type.advertisement} />;
      case 'sponsoredContent':
        return <SponsoredBanner {...type.sponsoredContent} />;
      default:
        return <TrackEmptyBanner />;
    }
  }, [type]);

  return (
    <>
      {banner}
      {highTierCouponBanner && isActive && (
        <CouponBanner banner={highTierCouponBanner} />
      )}
    </>
  );
};
